// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"d77eadc8","453":"cb7a2981"}[chunkId] + ".chunk.js";
};